// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2ESnJ","list":"PatternAutocomplete_list__2Az1_"};